<nb-layout [ngClass]="isShowBlock === true ? 'fix-menu' : ''">
  <nb-layout-header>
    <nb-actions>
      <nb-action>
        <a href="/"><img src="/assets/images/new_logo.svg" alt=""></a>
      </nb-action>
      <nb-action (click)="toggleSidebar()">
        <tui-icon icon="@tui.list"/>
      </nb-action>
      <nb-action>
        <a href="/">
          <tui-icon icon="@tui.house"/>
        </a>
      </nb-action>
      <nb-action (mouseenter)="search.openSearch()" (mouseleave)="search.closeSearch()">
        <app-menu-search #search [menuItems]="menuItems"/>
      </nb-action>
    </nb-actions>

    <nb-actions>
      <nb-action *ngIf="customer">
        <div [routerLink]="['cabinet', 'profile']" class="pointer">
          <!--          <img *ngIf="avatarImage" class="menu-close" [src]="avatarImage" alt="">-->
          <tui-icon icon="@tui.user-round"/>

          {{ customer.firstName + ' ' + customer.lastName }}
        </div>
      </nb-action>
      <nb-action (click)="logout()">
        <tui-icon icon="@tui.log-out"/>
      </nb-action>
    </nb-actions>
  </nb-layout-header>

  <nb-sidebar [state]="sideBarState" *ngIf="loaded">
    <nb-menu *ngIf="isShowBlock && menuItems?.length" [items]="menuItems" autoCollapse="true"></nb-menu>
    <app-compact-menu *ngIf="isShowMenu  && menuItems?.length" [items]="menuItems"></app-compact-menu>
  </nb-sidebar>
  <nb-layout-column>
    <app-state-topline></app-state-topline>
    <router-outlet *ngIf="loaded"></router-outlet>
  </nb-layout-column>
</nb-layout>
